/**
    商品列表
**/
<template>
        <div class="rightaside_content">
          <h3 class="headerTitle">订单详情</h3>
          <div class="headerButton">
              <span style="line-height: 28px;">订单号：<i>{{orderInfoList.orderNumber||'--'}}</i></span>
              <div v-if="iscancle?false:true">
                    <el-button  v-if="orderInfoList.status == 1?true:false" size="mini" @click="payOrderNow(orderInfoList.amount)">去支付</el-button>
                    <el-button v-if="orderInfoList.status == 1?true:false" size="mini" @click="cancleOrder(orderInfoList.oid)">取消订单</el-button>
                    <!-- <el-button v-if="orderInfoList.status==5 || orderInfoList.status==2?false:true" size="mini" @click="cancleOrder(orderInfoList.oid)">取消订单</el-button> -->
              </div>
              <!-- <div v-if="iscancle?true:false">
                   <el-button v-if="item.status==5?true:false" class="buttonStyle" type="danger" plain @click="removeOrder(orderInfoList.oid)">移出订单</el-button>
              </div> -->
          </div>
          <el-divider></el-divider>
          <div>
              <el-row class="order_goods" v-for='goodsItem in orderInfoList.bxyCommodityList' :key="goodsItem.id">
                    <el-col :span="2"> 
                        <!-- <el-image :src="`${goodsItem.photos}`"></el-image> -->
                         <el-image :src="`${goodsItem.photos}`">
                              <div slot="error" class="image-slot">
                                  <i class="el-icon-picture-outline"></i>
                              </div>
                          </el-image>
                    </el-col> 
                    <el-col :span="16" class="order_Info_item">
                        <p>{{goodsItem.name}}  {{goodsItem.specificationlist[0].name}}</p>
                        <!-- marketprice 需要乘以折扣 -->
                        <p>{{goodsItem.realprice}} 元 * {{goodsItem.number || 1}}</p>
                    </el-col>

                    <!-- 买家已付款了 退款按钮 -->
                    <el-col :span="4" class="order_Info_item">
                        <!-- 没有物流 先按交易成功算 -->
                        <el-button class="reBackMoney" v-if="orderInfoList.status==4?true:false" size="mini" @click="reBackMoney(goodsItem)">退款</el-button>
                       <!-- 没有物流 后期打开 -->
                        <!-- <el-button class="reBackMoney" v-if="orderInfoList.status==2?true:false" size="mini" @click="reBackMoney(goodsItem)">退款</el-button> -->
                    </el-col>  
                </el-row>

                <!-- 等待买家付款 -->
                <el-row class="order_goods">
                    <el-col :span="24" class="info_title">{{orderStatus(orderInfoList.status)}}</el-col> 
                    <el-col :span="24"  class="info_content">
                        <p>下单时间： {{orderInfoList.createTime}}</p>
                        <p>付款时间： {{orderInfoList.payAccount||'0000-00-00 00 ：00 ：00'}}</p>
                    </el-col>                             
                </el-row>

                <!-- 收货信息 后期开发-->
                   <el-row class="order_goods">
                    <el-col :span="24" class="info_title">收货信息</el-col> 
                    <el-col :span="24"  class="info_content">
                        <p>姓名： {{orderInfoList.bXyShoppingAddress.recipient}}</p>
                        <p>联系电话： {{orderInfoList.bXyShoppingAddress.phoneNumber}}</p>
                        <p>收货地址：  {{orderInfoList.areaName}}  {{orderInfoList.bXyShoppingAddress.address}}</p>
                    </el-col>                             
                </el-row>

                <!-- 物流信息 后期开发-->
                <!-- <el-row class="order_goods">
                    <el-col :span="24" class="info_title">物流信息</el-col> 
                    <el-col :span="24"  class="info_content">
                        <p>物流号： {{'2020-12-06 22：22：22'}}</p>
                        <p>付款时间： {{'0000-00-00 00：22：22'}}</p>
                    </el-col>                             
                </el-row> -->

                <!-- 支付方式及送货时间 后期开发-->
                <!-- <el-row class="order_goods">
                    <el-col :span="24" class="info_title">支付方式及送货时间</el-col> 
                    <el-col :span="24"  class="info_content">
                        <p>支付方式： {{'在线支付'}}</p>
                        <p>送货时间： {{'0000-00-00 00：22：22'}}</p>
                    </el-col>                             
                </el-row> -->

                <!-- 发票信息 -->
                <el-row class="order_goods">
                    <el-col :span="24" class="info_title">发票信息</el-col> 
                    <el-col :span="24"  class="info_content">
                        <p>发票类型： {{'电子发票'}}</p>
                        <p>发票内容： {{'发票抬头 - 未填写'}}</p>
                    </el-col>                             
                </el-row>

                 <!-- 商品总价 -->
                <el-row class="footer_total">
                    <el-col :span="20">
                        <p>商品总价:</p>
                        <p>运费:</p>
                        <p>总全额:</p>
                    </el-col>
                    <el-col :span="4"  class="footer_total_money">
                        <p>{{orderInfoList.amount || 0}} 元</p>
                        <p>{{'0.00'}} 元</p>
                        <p class="finalTotal">{{orderInfoList.amount||0}} 元</p>
                    </el-col>                             
                </el-row>

          </div>

        </div>
</template>
<script>
import {cancleOrderItem,removeOrderItem} from '@/api/xunyou'
export default {
  data() {
    return {
        iscancle:false,
        isremove:false,
        searchValue:'',    
        orderInfoList:JSON.parse(sessionStorage.getItem("orderDetail")) || [],    
        // orderInfoList:{
        //         id:0,
        //         status:1, // 1等待买家付款 2等待卖家发货 3等待买家确认收获 4交易成功 5交易关闭
        //         time:'2020-12-1 22:22:22',
        //         shopName:'POLA宝丽官方旗舰店',
        //         orderNum:'DD-20201204-0009',
        //         orderTotal:725,
        //         goodsList:[
        //                 {
        //                    id:0,
        //                    photos:'',
        //                    proTitle: 'SK-II大红瓶面部护肤精华面霜提亮修护补水饱满弹润官方sk2skll',
        //                    price:123,
        //                    number:1,
        //                 },
        //                 {
        //                    id:1,
        //                    photos:'',
        //                    proTitle: 'Dior迪奥 迪奥小姐香水 经典女士香水 迷人馥郁花香',
        //                    price:123,
        //                    number:1,
        //                 },
        //                  {
        //                    id:2,
        //                    photos:'',
        //                    proTitle: 'SK-II大红瓶面部护肤精华面霜提亮修护补水饱满弹润官方sk2skll',
        //                    price:123,
        //                    number:1,
        //                 },
        //                 {
        //                    id:3,
        //                    photos:'',
        //                    proTitle: 'Dior迪奥 迪奥小姐香水 经典女士香水 迷人馥郁花香',
        //                    price:123,
        //                    number:1,
        //                 }
        //             ]
        //     }
    }
  },
  // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

      //   订单状态转换
    orderStatus(status){
        switch(status) {
            case 1:
                return '等待买家付款'
                break;
            case 2:
                 return '等待卖家发货'
                break;
            case 3:
                 return '等待买家确认收货'
                break;
            case 4:
                 return '交易成功'
                break;
            case 5:
                 return '交易关闭'
                break;
            default:
                
                return '--'
        } 
    },

    // 立即支付
    payOrderNow(amount){
        sessionStorage.setItem("account", JSON.stringify(amount || 0)); 
        sessionStorage.setItem("orderGoodsInfo", JSON.stringify([this.orderInfoList])); 
        this.$router.push('/orderNow')
    },

      //   取消订单
     cancleOrder(orderId) {
        this.$confirm('确定取消订单?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
             cancleOrderItem({oid:orderId}).then(res => {
              if (res.code == 0) {
                this.$message({
                    type: 'success',
                    message: '取消成功!'
                });
                this.iscancle = true
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('取消失败，请稍后再试！')
            })          
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });          
        });
      },
      //   移出订单
    removeOrder(orderId){
        this.$confirm('确定移除订单吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
           removeOrderItem({oid:orderId}).then(res => {
              if (res.code == 0) {
                this.$message({
                    type: 'success',
                    message: '移除成功!'
                });
                this.isremove = true
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('移除失败，请稍后再试！')
            })   
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已移除'
          });          
        });
    },
    // 退款
    reBackMoney(goodsItem){        
        const myRefundInfo = {
            orderNumber:this.orderInfoList.orderNumber,
            goodsItem
        }
        console.log(myRefundInfo,'退库随你啦')
        sessionStorage.setItem('myRefundInfo',  JSON.stringify(myRefundInfo))
        this.$router.push('/myRefund_supplier')

    }
  },
};
</script>

<style scoped lang="less">
    .rightaside_content{
        .el-divider--horizontal {
            display: block;
            height: 1px;
            width: 100%;
            margin: 5px 0;
        }
        .headerTitle{
            font-size: 20px;
            height: 40px;
            line-height: 40px;
            color: #666;
        }
        .headerButton {
            display: flex;
            justify-content: space-between;
            button.el-button.el-button--default.el-button--mini {
                // background: #ff6700;
                // color: white;
                background: #f896521a;
                color: #ff6700;
                border: 1px solid #ff6700;
            }
            .el-button.el-button--mini:focus, .el-button.el-button--mini:hover {
                background: #ff6700 !important;
                color: white !important;
            }
        }
        .order_goods.el-row {
            border-bottom: 1px solid#DCDFE6;
            padding: 20px;
            box-sizing: border-box;
             .order_Info_item {
                margin-left: 10px;
            }
        }
        .info_title{
            margin: 0 0 15px;
            font-size: 16px;
            font-weight: 400;
            color: #333;
        }
        .info_content{
                color: #757575;
                p{
                    margin-bottom: 4px;
                }
        }
        .footer_total{
                text-align: right;
                color: #757575;
                p{
                    margin: 10px 0;
                }
                .footer_total_money{
                    color: #ff6700;
                    .finalTotal{
                        font-size: 20px;
                    }
                }
                
        }
        button.el-button.reBackMoney.el-button--default.el-button--mini {
            background: #ff674c;
            color: white;
            border: 1px solid #ff674c;
        }
        button.el-button.reBackMoney.el-button--default.el-button--mini:hover {
            background: #f896521a;
            color:  #ff674c;
            border: 1px solid #ff674c;
        }
       

    }

</style>

 
 

 


// WEBPACK FOOTER //
// src/views_supplier/myOrder/myOrderDetail.vue